<template>
  <div class="br-subleft overflow-y-auto" :data-min="status">
    <div>
      <h6
        class="tx-uppercase tx-10 tx-mont tx-spacing-1 mg-t-10 pd-x-10 tx-white-7"
      >
        {{ $t("mall.条件筛选") }}
      </h6>
      <div class="mg-t-10 pd-x-10 mg-b-40">
        <div class="mg-b-15 form-group">
          <input
            type="text"
            :placeholder="$t('mall.标签名称')"
            class="form-control form-control-dark tx-14"
            v-model.trim="name"
            @keyup.enter="filtrate()"
          />
        </div>
        <div class="form-group mg-b-15">
          <select
            class="form-control form-control-dark"
            v-model="kStatus"
            @change="filtrate"
          >
            <option value="">{{ $t("mall.是否在商城显示") }}</option>
            <option v-for="(s, k) in $dict.labelStatus" :key="k" :value="k">
              {{ $t(s) }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <button
      class="btn btn-primary search btn-block tx-uppercase tx-11 tx-spacing-2 tx-medium"
      @click="filtrate"
    >
      {{ $t("mall.筛 选") }}
    </button>
    <!-- todo3-标签管理 -->
    <button
      @click="batchSearch('mallLabel')"
      class="
        btn btn-primary batchSearch btn-block
        tx-uppercase tx-11 tx-spacing-2 tx-medium
      "
    >
      {{ $t("distributor.批量搜索") }}
    </button>
  </div>
</template>

<script>
export default {
  props: ["status", "keyName", "keyStatus"],
  data() {
    return {
      name: "",
      kStatus: "",
    };
  },
  watch: {
    keyName() {
      this.name = this.keyName;
    },
    keyStatus() {
      this.kStatus = this.keyStatus;
    },
  },
  methods: {
    batchSearch(key){
      this.$emit('batchSearch', key)
    },
    filtrate() {
      this.$emit("filtrate", this.name, this.kStatus);
    },
  },
  mounted() {},
  updated() {},
};
</script>